import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EngineeringService {

  //readonly rootUrl = "";
  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService) { }

  GetPurchaseOrderList() {
    return this.http.get(this.rootUrl + '/api/Engineering/GetPurchaseOrderList');
  }

  GetPurchaseOrderForVendor() {
    return this.http.get(this.rootUrl + '/api/Engineering/GetPurchaseOrderForVendor');
  }

  GetPurchaseLineList() {
    return this.http.get(this.rootUrl + '/api/Engineering/GetPurchaseLineList');
  }


  uploadMdl(formData) {
    return this.http.post(this.rootUrl + '/api/Engineering/UploadMdl', formData);
  }

  getMdlList() {
    return this.http.get(this.rootUrl + '/api/Engineering/GetMdlList');
  }

  GetMdlById(id) {
    const mdl = {
      mdlId: id
    }

    return this.http.post(this.rootUrl + '/api/Engineering/GetMdlById', mdl);
  }

  AssignDrawingVendor(form) {
    return this.http.post(this.rootUrl + '/api/Engineering/AssignDrawingVendor', form);
  }

  UpdateDrawingVendor(form) {
    return this.http.post(this.rootUrl + '/api/Engineering/UpdateDrawingVendor', form);
  }

  GetMdlListVendor() {
    return this.http.get(this.rootUrl + '/api/Engineering/GetMdlListVendor');
  }

  GetDrawingById(id) {
    const mdl = {
      mdlId: id
    }

    return this.http.post(this.rootUrl + '/api/Engineering/GetDrawingById', mdl);
  }

  SubmitVendorDrawing(form) {
    return this.http.post(this.rootUrl + '/api/Engineering/SubmitVendorDrawing', form);
  }

  GetAllSubmittedDrawings() {
    return this.http.get(this.rootUrl + '/api/Engineering/GetAllSubmittedDrawings');
  }

  GetSubmittedDrawingsVendor() {
    return this.http.get(this.rootUrl + '/api/Engineering/GetSubmittedDrawingsVendor');
  }

  UploadDrawingDocument(formData) {
    return this.http.post(this.rootUrl + '/api/Engineering/UploadDrawingDocument', formData);
  }

  GetDrawingDocs(formData) {
    return this.http.post(this.rootUrl + '/api/Engineering/GetDrawingDocs', formData);
  }

  GetInitialDrawingDocs(formData) {
    return this.http.post(this.rootUrl + '/api/Engineering/GetInitialDrawingDocs', formData);
  }

  RemoveDrawingDocs(id) {
    const doc = {
      docId: id
    }
    return this.http.post(this.rootUrl + '/api/Engineering/RemoveDrawingDocs', doc);
  }

  submitDrawingComments(form) {
    return this.http.post(this.rootUrl + '/api/Engineering/SubmitDrawingComments', form);
  }

  getDrawingComments(drawinglibid, mdllistid) {
    const commnt = {
      drawingLibId: drawinglibid,
      mdlListId: mdllistid
    }
    return this.http.post(this.rootUrl + '/api/Engineering/GetDrawingComments', commnt);
  }
  searchmdl(keywrd) {
    const key = {
      keyword: keywrd

    }
    return this.http.post(this.rootUrl + '/api/Engineering/Searchmdl', key);

  }
  searchsubdrawing(keywrd) {
    const key = {
      keyword: keywrd

    }
    return this.http.post(this.rootUrl + '/api/Engineering/searchsubdrawing', key);

  }
  SmtDrawingVendorSearch(keywrd) {
    const key = {
      keyword: keywrd
    }
    return this.http.post(this.rootUrl + '/api/Engineering/SmtDrawingVendorSearch', key);
  }
  MDLListVendorSearch(keywrd) {
    const key = {
      keyword: keywrd
    }
    return this.http.post(this.rootUrl + '/api/Engineering/MDLListVendorSearch', key);
  }

  ApproveDrawingDoc(id) {
    const doc = {
      docId: id
    }
    return this.http.post(this.rootUrl + '/api/Engineering/ApproveDrawingDoc', doc);
  }

  RejectDrawingDoc(id) {
    const doc = {
      docId: id
    }
    return this.http.post(this.rootUrl + '/api/Engineering/RejectDrawingDoc', doc);
  }
  GetPurchaseline(ponumber) {
    debugger;
    var data = {
      pono: ponumber
    }
    return this.http.post(this.rootUrl + '/api/Engineering/GetPurchaseline', data);

  }

  GetOrderById(id) {
    const order = {
      OrderId: id
    }
    return this.http.post(this.rootUrl + '/api/Engineering/getOrderById', order);
  }

  SubmitTransportDetails(form) {
    debugger;
    return this.http.post(this.rootUrl + '/api/Engineering/SubmitTransportDetails', form);
  }

  searchPurchase(keywrd){
    const key = {
      keyword : keywrd
    }
    return this.http.post(this.rootUrl + '/api/Engineering/SearchPurchase', key);
  }

}
